<template>
   <v-list-item
        :class="{ 'active': material.active }"
        :ripple="false"
        @click="roomItem.type === 'harmony' ? applyHarmony(materialIndex) : applyMaterial(material)"
    >
        <!-- MATERIAL PREVIEW -->
        <v-list-item-icon class="material-preview d-flex justify-center mr-2">
            
            <v-img
                v-if="roomItem.type !== 'harmony'"
                class="rounded-circle preview"
                contain
                :src="material.img"
            />
            <v-img
                v-else
                v-for="(material,  materialIndex) in lightHarmonyMaterials"
                :key="`material-${materialIndex}`"
                :class="{ 'ml-n4': materialIndex != 0 && materialIndex != harmonyMaterials.length }"
                class="preview"
                :src="material.text.img"
            />
        </v-list-item-icon>
        <!-- /MATERIAL PREVIEW -->

        <!-- MATERIAL DESCRIPTION -->
        <v-list-item-content class="material-description">
            <v-list-item-title
                v-if="material.name"
                class="text-none toCapitalFirst"
            >
                {{ material.name }}
            </v-list-item-title>
            <v-list-item-title v-else>
                <span
                    v-for="(materialObj, materialObjIndex) in harmonyMaterials"
                    :key="`material-text-${materialObjIndex}`"
                    class="text-none"
                >
                    <span class="toCapitalFirst">
                        {{ (materialObjIndex > 0 ? '/ ' : '' ) + `${materialObj.text}` }}
                    </span>
                </span>
            </v-list-item-title>
        </v-list-item-content>
        <!-- /MATERIAL DESCRIPTION -->

        <HarmonyMaterials
            v-if="roomItem.type === 'harmony' && material.name"
            :materials="harmonyMaterials"
            :harmonyName="material.name"
        />
    </v-list-item>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import HarmonyMaterials from '@/components/configurableTour/components/HarmonyMaterials';

    export default {
        name: 'RoomItem',
        props: {
            roomItem: {
                type: Object,
                required: true
            },
            roomItems: {
                type: Array
            },
            material: {
                type: Object,
                required: true
            },
            materialIndex: {
                type: Number
            },
            harmonyMaterials: {
                type: Array
            }
        },
        components: {
            HarmonyMaterials
        },
        computed: {
            lightHarmonyMaterials() {
                return this.$props.harmonyMaterials.slice(0, 2);
            }
        },
        methods: {
            applyMaterial(currentMaterial) {
                let harmonyItems = this.$props.roomItems.filter(item => item.type === 'harmony');
                if (harmonyItems.length) {
                    harmonyItems.forEach(harmony => {
                        harmony.materials.forEach(material => material.active = false);
                    });
                }
                this.$props.roomItem.materials.forEach(material => material.active = false);
                this.$props.roomItem.materials.forEach(material => {
                    material.active = material.id === currentMaterial.id;
                });
                EventBus.$emit('updateMaterials', this.$props.roomItem, currentMaterial);
            },
            applyHarmony(index) {
                let roomItems = [];
                this.$props.roomItem.materials.forEach(material => material.active = false);
                this.$props.material.active = true;
                Object.keys(this.$props.roomItem.materials[index].combinations).forEach(roomItemId => {
                    let roomItemIndex = this.$props.roomItems.findIndex(roomItem => roomItem.id === roomItemId);
                    if (this.$props.roomItems[roomItemIndex]) {
                        this.$props.roomItems[roomItemIndex].materials.forEach(material => material.active = false);

                        let roomItemToUpdate = this.$props.roomItems[roomItemIndex];
                        let materialIndex = roomItemToUpdate.materials.findIndex(material => material.id === this.$props.roomItem.materials[index].combinations[roomItemId]);
                        roomItemToUpdate.materials[materialIndex].active = true;
                        roomItems.push(roomItemToUpdate);
                    }
                });
                EventBus.$emit('applyHarmony', this.$props.roomItem, roomItems);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .material {
        &-preview {
            align-self: center;
        }
        &-description {
            padding: 12px 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-align: start;
            align-self: center;
            .v-list-item__title {
                white-space: unset;
            }
        }
    }
.toCapitalFirst {
  text-transform: lowercase !important;
  &:first-letter {
    text-transform: capitalize;
  }
}
    .preview {
        width: 24px;
        height: 24px;
        max-width: 24px;
        border: 1px solid rgba(39, 34, 34, 0.11);
        border-radius: 24px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configurableTour/components/RoomItem.vue